/**
 * @returns {React.JSX.Element}
 */
export function PinIcon() {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
      <path
        d="M6.64868 0.599609C7.72281 0.599609 8.75342 1.01412 9.51294 1.75098C10.2723 2.4878 10.6985 3.48737 10.6985
          4.5293C10.6984 7.96467 6.64868 11.4004 6.64868 11.4004C6.64868 11.4004 2.599 7.96467 2.59888 4.5293C2.59888
          3.48737 3.0251 2.4878 3.78442 1.75098C4.54395 1.01412 5.57455 0.599609 6.64868 0.599609ZM6.64966
          3.05859C5.81234 3.05859 5.13306 3.71696 5.13306 4.5293C5.13311 5.34158 5.81237 6 6.64966 6C7.48684
          5.99988 8.16523 5.34151 8.16528 4.5293C8.16528 3.71704 7.48687 3.05871 6.64966 3.05859Z"
      />
    </svg>
  );
}
